<template>
    <div class="center-box">
        <div class="searchBox">
            <a-space  class=" mr-10">
                <a-input class="keyword"  allowClear v-model:value="queryParams.searchKey"  @pressEnter="changePage"
                    placeholder="请输入关键字" />
            </a-space>
            <a-button  type="primary" @click="changePage">查询</a-button>
        </div>

        <a-table :data-source="modelList" align="center" class="mt10" :pagination="paginationProp" row-key="id"  @change="refreshData">
                <a-table-column  align="center" key="name" title="模型名称" data-index="name" />
                <a-table-column  align="center" key="modelNo" title="序列号" data-index="modelNo" />
                <a-table-column  align="center" key="latestTrainingTime" title="最近训练时间" data-index="latestTrainingTime" >
                  <template #default="{ record }">
                    {{ moment(record.latestTrainingTime).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="onlineTime" title="上线时间" data-index="onlineTime" >
                  <template #default="{ record }">
                    {{ moment(record.onlineTime).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="labelList" title="标签列表" data-index="labelList" ellipsis width="200"/>
                <a-table-column  align="center" key="status" title="状态" data-index="status" >
                  <template #default="text">
                    {{ text?'正常':'停用' }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="createTime" title="创建时间" data-index="createTime" >
                  <template #default="{ record }">
                    {{ moment(record.createTime).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
        </a-table>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick, watch, reactive } from 'vue'
import { getAlgorithmModelListPageVo, getAiTypeDataDict } from '/@/api/manage'
import { ELocalStorageKey } from '/@/types'
import moment from 'moment'

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const queryParams = ref({
  page_num: 1,
  page_size: 10,
  algorithm_type: null,
  searchKey: null,
  workspace_id: workspaceId
})
const modelList = ref([])

const paginationProp = reactive({
  showQuickJumper: false,
  showSizeChanger: false,
  page_size: 10,
  current: 1,
  total: 0
})
const algorithmTypeOptions = ref([])
onMounted(() => {
  getAiTypeDataDict().then(res => {
    if (res.code === 0) {
      algorithmTypeOptions.value = res.data.data
      getList()
    }
  })
})
function changePage () {
  queryParams.value.page_num = 1
  getList()
}
function refreshData (page:any) {
  queryParams.value.page_num = page.current
  getList()
}
function getList () {
  getAlgorithmModelListPageVo(queryParams.value).then(res => {
    if (res.code === 0) {
      modelList.value = res.data.list
      paginationProp.total = res.data.pagination.total
      paginationProp.current = res.data.pagination.page
      modelList.value.forEach(el => {
        el.algorithmTypeName = algorithmTypeOptions.value.find(item => item.id === el.algorithmType)?.name
      })
    }
  })
}
</script>

<style lang="scss" scoped>

</style>
